<template>
  <div>
    <div class="container" v-if="show">
      <!-- 商机信息 -->
      <div class="card">
        <!-- <div class="title">
          <span v-if="applyInfo.verifyStatus != 1">
            <van-icon name="edit" color="#f8df0d" size="20px" class="icon-edit" style="padding-left:15px;" v-hasPermi="['cont:apply:edit']" @click="handleAddContract"/>
            <van-icon name="delete" color="red" size="20px" class="icon-delete" v-hasPermi="['cont:apply:remove']" @click="applyDelete" />
          </span>
        </div> -->
        <div class="title">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-post"></use>
          </svg>
          <span>{{applyInfo.serviceTypeName}}</span>
        </div>
        <div class="list-wrap van-hairline--top">
          <div class="item" style="width:100%">
            <span class="key">业务类型：</span>
            <span class="value">{{ applyInfo.serviceTypeName }}</span>
          </div>
          <div class="item" style="width:100%">
            <span class="key">部门名称：</span>
            <span class="value">{{applyInfo.deptName}}</span>
          </div>
          <div class="item" style="width:100%">
            <span class="key">申请份数：</span>
            <span class="value">{{ applyInfo.applyCount }}(份)</span>
          </div>
          <div class="item" style="width:100%">
            <span class="key">申请人：</span>
            <span class="value">{{ applyInfo.applyName }}</span>
          </div>
          <div class="item" >
            <span class="key">申请时间：</span>
            <span class="value">{{ applyInfo.createTime }}</span>
          </div>
          <div class="item" >
            <span class="key">申请说明：</span>
            <span class="value">{{ applyInfo.remark }}</span>
          </div>
          <div v-if="applyInfo.verifyStatus == 1">
            <div class="item" >
              <span class="key">审核人：</span>
              <span class="value">{{ applyInfo.reviewerName }}</span>
            </div>
            <div class="item" >
              <span class="key">审核时间：</span>
              <span class="value">{{ applyInfo.reviewerTime }}</span>
            </div>
            <div class="item" >
              <span class="key">审核状态：</span>
              <span class="value">
                <van-tag type="success" plain>通过</van-tag>
              </span>
            </div>
            <div class="item" >
              <span class="key">合作类型：</span>
              <span class="value">{{contPartnerTypeDetails(applyInfo.contPartnerType)}}</span>
            </div>
            <div class="item" >
              <span class="key">审核意见：</span>
              <span class="value">{{ applyInfo.reviewerText }}</span>
            </div>
          </div>
        </div>
      </div>
       <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" v-if="applyInfo.verifyStatus != 1" :column-num="3">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:apply:edit']" @click="handleAddContract">
            <van-icon name="edit" size="22" color="#07c160" />
            <span>修改</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:apply:remove']" @click="applyDelete">
            <van-icon name="delete" size="22" color="#ee0a24" />
            <span>删除</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:apply:reviewer']" @click="handleVerify(applyInfo)">
            <van-icon name="certificate" size="22" color="#1989fa" />
            <span>审核</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-dialog v-model="verifyFormShow" title="合同申领审核" width="95%" style="height:50%" class="verifyClue" :beforeClose="verifyBeforeClose" show-cancel-button>
        <van-form ref="verifyForm" validate-trigger="onSubmit">
          <van-field v-model="verifyForm.applyCount" label="发放份数：" type="digit" placeholder="请输入发放份数" maxlength="2" :rules="[{ required: true,pattern: /^([1-9]|[12][0-9]|30)$/, message: '一次最多发放30份！'}]" required />
          <van-cell title="审核：" required>
            <template>
              <van-radio-group v-model="verifyForm.verifyStatus" direction="horizontal">
                <van-radio name="1" clickable @click="verifyForm.verifyStatus = '1'">通过</van-radio>
                <van-radio name="2" clickable @click="verifyForm.verifyStatus = '2'">不通过</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field
            v-model="verifyForm.reviewerText"
            rows="2"
            autosize
            label="审核意见"
            placeholder="请输入审核意见"
            type="textarea"
            show-word-limit
          />
        </van-form>
      </van-dialog>
    </div>
    <dialog-apply :show='edit_show' :isAdd='false' :modifyObj="applyInfo" @handleAddContractCancel='handleAddContractCancel' @beforeClose='addContractBeforeClose' ></dialog-apply>
  </div>
</template>

<script>
import moment from 'moment'
import { getApplyCont, deleteApplyCont, auditApplyCont } from '@/api/cont/contract'
// import { getDicts } from '@/api/system/dict/data'
import { Toast, Dialog } from 'vant'
import DialogApply from '../components/DialogApply.vue'
export default {
  components: {
    DialogApply,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      show: false,
      edit_show: false,
      verifyFormShow: false,
      templateApplyId: '',
      contPartnerTypeOptions: [],
      radio: '1',
      applyInfo: {},
      verifyForm: {
        applyCount: '',
        verifyStatus: '1',
        reviewerText: ''
      },
      form: []
    }
  },
  async created() {
    this.templateApplyId = this.$route.query.templateApplyId
    await this.getApplyInfo()
    this.getDicts('cont_partner_type').then(res => {
      this.contPartnerTypeOptions = res.data
    })
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '合同申领详情'
    },
    async getApplyInfo() {
      const res = await getApplyCont(this.templateApplyId)
      if (res.code === 200) {
        this.applyInfo = res.data
        this.show = true
      }
    },
    handleVerify() {
      this.verifyFormShow = true
    },
    async verifyBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.verifyForm.validate()
          const applyInfo = this.applyInfo
          const verifyForm = this.verifyForm
          this.applyInfo = { ...applyInfo, ...verifyForm }
          this.form.push(this.applyInfo)
          await auditApplyCont(JSON.stringify(this.form))
          await this.reset()
            .then(() => {
              Toast.success('审核成功!')
              this.verifyFormShow = false
              // this.getApplyInfo()
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.verifyFormShow = false
      }
    },
    // 清空表单
    async reset() {
      this.verifyForm = {
        applyCount: '',
        verifyStatus: '1',
        reviewerText: ''
      }
    },
    // async audit(){
    //   await this.$refs["verifyForm"].validate();
    //   let applyInfo = this.applyInfo
    //   let verifyForm = this.verifyForm
    //   this.applyInfo = { ...applyInfo, ...verifyForm }
    //   // this.applyInfo.applyCount = this.verifyForm.applyCount
    //   // this.applyInfo.verifyStatus = this.verifyForm.verifyStatus
    //   // this.applyInfo.reviewerText = this.verifyForm.reviewerText
    //   this.form.push(this.applyInfo)
    //   const res = await auditApplyCont(JSON.stringify(this.form))
    //   if (res.code === 200) {
    //     await Toast.success("审核成功!")
    //     this.$router.go(-1)
    //   }
    // },
    async applyDelete() {
      Dialog.confirm({
        message: '是否确认删除此条数据'
      })
        .then(() => {
          this.delete()
        })
        .catch(() => {
        // on cancel
        })
    },
    async delete() {
      const res = await deleteApplyCont(this.templateApplyId)
      if (res.code === 200) {
        await Toast.success('成功删除!')
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      }
    },
    handleAddContract() {
      this.edit_show = true
    },
    handleAddContractCancel() {
      this.edit_show = false
    },
    // 修改合同
    async addContractBeforeClose() {
      this.edit_show = false
      await this.getApplyInfo()
    },
    /// /合作类型
    contPartnerTypeDetails(val) {
      return this.selectDictLabel(this.contPartnerTypeOptions, val)
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
/deep/ .van-field__label {
  color: #323233;
}

.verifyClue /deep/.van-dialog__content {
  height: 68%;
}
</style>
